<template>
  <div class="solar-plant-items">
    <b-row>
      <b-col lg="10" md="6" sm="12">
        <strong>{{ $t('inverter') }}</strong>
      </b-col>
      <b-col lg="2" md="6" sm="12">
        <div class="text-center border p-1 ">
          <strong>{{ InverterNominalPowerOverall }} kW</strong>
        </div>
      </b-col>
    </b-row>

    <b-row>
      <b-col lg="10" md="6" sm="12">
        <b-form-group
          horizontal
          :label="$t('inverter1')"
          label-for="inverter"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
          :invalid-feedback="invalidFeedbackNA"
          :state="requirementsValidState('inverter1')"
        >
          <multiselect
            :placeholder="$t('inverter1')"
            v-model="project.solarPlant.inverter1Item"
            id="inverter1"
            :options="filteredInverters"
            :allow-empty="true"
            :show-labels="false"
            track-by="_id"
            v-on:search-change="onInverterSearch"
            :internal-search="false"
            :preserve-search="true"
          >
            <template slot="singleLabel" slot-scope="{ option }">
              {{ option.inverter?.manufacturer }} - {{ option.inverter?.type }}
            </template>
            <template slot="option" slot-scope="{ option }">
              {{ option.inverter?.manufacturer }} - {{ option.inverter?.type }}
            </template>
          </multiselect>
        </b-form-group>
      </b-col>
      <b-col lg="2" md="6" sm="12">
        <div class="text-center border p-1 mt-1">{{ inverter1Power }} kW</div>
      </b-col>
    </b-row>

    <b-row>
      <b-col lg="10" md="6" sm="12">
        <b-form-group
          horizontal
          :label="$t('inverter2')"
          label-for="inverter2"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <multiselect
            :placeholder="$t('inverter2')"
            v-model="project.solarPlant.inverter2Item"
            id="inverter2"
            :options="filteredInverters"
            :allow-empty="true"
            :show-labels="false"
            track-by="_id"
            v-on:search-change="onInverterSearch"
            :internal-search="false"
          >
            <template slot="singleLabel" slot-scope="{ option }">
              {{ option.inverter?.manufacturer }} - {{ option.inverter?.type }}
            </template>
            <template slot="option" slot-scope="{ option }">
              {{ option.inverter?.manufacturer }} - {{ option.inverter?.type }}
            </template>
          </multiselect>
        </b-form-group>
      </b-col>
      <b-col lg="2" md="6" sm="12">
        <div class="text-center border p-1 ">{{ inverter2Power }} kW</div>
      </b-col>
    </b-row>

    <b-row>
      <b-col lg="10" md="6" sm="12">
        <strong>{{ $t('solarPanel') }}</strong>
      </b-col>
      <b-col lg="2" md="6" sm="12">
        <div class="text-center border p-1 ">
          <strong>{{ solarPanelsOverallPower }} kWp</strong>
        </div>
      </b-col>
    </b-row>

    <b-row>
      <b-col lg="10" md="6" sm="12">
        <b-form-group
          horizontal
          :label="$t('solarPanel')"
          label-for="solarPanel"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
          :invalid-feedback="invalidFeedbackNA"
          :state="requirementsValidState('solarPanel')"
        >
          <multiselect
            :placeholder="$t('solarPanel')"
            v-model="project.solarPlant.solarPanelItem"
            id="solarPanel"
            :options="filteredSolarPanels"
            track-by="_id"
            v-on:search-change="onSolarPanelSearch"
            :internal-search="false"
            :show-labels="true"
            :deselectLabel="$t('deselectLabel')"
            selectLabel=""
            selectedLabel=""
            :preserve-search="true"
          >
            <template slot="singleLabel" slot-scope="{ option }">
              {{ option.solarPanel?.manufacturer || option.manufacturer }} -
              {{ option.solarPanel?.type || option.type }}
            </template>
            <template slot="option" slot-scope="{ option }">
              {{ option.solarPanel?.manufacturer || option.manufacturer }} -
              {{ option.solarPanel?.type || option.type }}
            </template>
          </multiselect>
        </b-form-group>
      </b-col>
      <b-col lg="2" md="6" sm="12">
        <div class="text-center border p-1 mt-1">
          {{ solarPanelPower }}
          Wp
        </div>
      </b-col>
    </b-row>

    <b-row>
      <b-col lg="10" md="6" sm="12">
        <b-form-group
          horizontal
          :label="$t('solarPanelCount')"
          label-for="solarPanelCount"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
          :invalid-feedback="invalidFeedbackNA"
          :state="requirementsValidState('solarPanelCount')"
        >
          <b-form-input
            v-model="project.solarPlant.solarPanelCount"
            type="text"
            :placeholder="$t('solarPanelCount')"
            :state="requirementsValidState('solarPanelCount')"
          />
        </b-form-group>
      </b-col>
      <b-col lg="2" md="6" sm="12"> </b-col>
    </b-row>

    <b-row>
      <b-col lg="10" md="6" sm="12">
        <strong>{{ $t('battery') }}</strong>
      </b-col>
      <b-col lg="2" md="6" sm="12"> </b-col>
    </b-row>
    <b-row>
      <b-col lg="10" md="6" sm="12">
        <b-form-group
          horizontal
          :label="$t('battery')"
          label-for="battery"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <multiselect
            :placeholder="$t('battery')"
            v-model="project.solarPlant.batteryItem"
            id="battery"
            :options="filteredBatteries"
            :allow-empty="true"
            :show-labels="false"
            track-by="_id"
            v-on:search-change="onBatterySearch"
            :internal-search="false"
          >
            <template slot="singleLabel" slot-scope="{ option }">
              {{ option.battery?.manufacturer }} - {{ option.battery?.type }}
            </template>
            <template slot="option" slot-scope="{ option }">
              {{ option.battery?.manufacturer }} - {{ option.battery?.type }}
            </template>
          </multiselect>
        </b-form-group>
      </b-col>
      <b-col lg="2" md="6" sm="12">
        <div class="text-center border p-1 mt-1">{{ batteryCapacity }} kWh</div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="10" md="6" sm="12"> </b-col>
      <b-col lg="2" md="6" sm="12">
        <div class="text-center border p-1 mt-1" v-if="project.solarPlant.battery">
          <span>{{ $t(project.solarPlant.battery.connectionType) }}</span>
        </div>
      </b-col>
    </b-row>

    <b-row>
      <b-col lg="10" md="6" sm="12">
        <strong>{{ $t('additionalComponents') }}</strong>
      </b-col>
      <b-col lg="2" md="6" sm="12"> </b-col>
    </b-row>
    <b-row>
      <b-col lg="10" md="6" sm="12">
        <b-form-group
          horizontal
          :label="$t('energyFlowDirectionSensor_short')"
          label-for="energyFlowDirectionSensor"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <multiselect
            :placeholder="$t('energyFlowDirectionSensor_short')"
            v-model="project.solarPlant.energyFlowDirectionSensorItem"
            id="energyFlowDirectionSensor"
            :options="filteredEnergyFlowFirectionSensors"
            :allow-empty="true"
            :show-labels="false"
            track-by="_id"
            v-on:search-change="onEnergyFlowDirectionSensorSearch"
            :internal-search="false"
          >
            <template slot="singleLabel" slot-scope="{ option }">
              {{ option.energyFlowDirectionSensor?.manufacturer }} -
              {{ option.energyFlowDirectionSensor?.type }}
            </template>
            <template slot="option" slot-scope="{ option }">
              {{ option.energyFlowDirectionSensor?.manufacturer }} -
              {{ option.energyFlowDirectionSensor?.type }}
            </template>
          </multiselect>
        </b-form-group>
      </b-col>
      <b-col lg="2" md="6" sm="12"> </b-col>
    </b-row>
    <b-row>
      <b-col lg="10" md="6" sm="12">
        <b-form-group
          horizontal
          :label="$t('wallbox')"
          label-for="wallbox"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <multiselect
            :placeholder="$t('wallbox')"
            v-model="project.solarPlant.wallboxItem"
            id="wallbox"
            :options="filteredWallboxes"
            :allow-empty="true"
            :show-labels="false"
            track-by="_id"
            v-on:search-change="onWallboxSearch"
            :internal-search="false"
          >
            <template slot="singleLabel" slot-scope="{ option }">
              {{ option.wallbox?.manufacturer }} - {{ option.wallbox?.type }}
            </template>
            <template slot="option" slot-scope="{ option }">
              {{ option.wallbox?.manufacturer }} - {{ option.wallbox?.type }}
            </template>
          </multiselect>
        </b-form-group>
      </b-col>
      <b-col lg="2" md="6" sm="12">
        <div class="text-center border p-1 mt-1">
          <span v-if="project.solarPlant.wallbox">{{
            project.solarPlant.wallbox.maxNetInputPower
          }}</span>
          kW
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="10" md="6" sm="12">
        <b-form-group
          horizontal
          :label="$t('emergencyPowerState')"
          label-for="emergencyPowerState"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <multiselect
            :placeholder="$t('emergencyPowerState')"
            v-model="project.solarPlant.emergencyPowerState"
            :options="optionsYesNo"
            :show-labels="false"
            :allow-empty="false"
          >
            <template slot="singleLabel" slot-scope="{ option }"
              ><b-badge :variant="yesNoColor(option)">{{ $t(option) }}</b-badge></template
            >
            <template slot="option" slot-scope="{ option }">
              <b-badge :variant="yesNoColor(option)">
                {{ $t(option) }}
              </b-badge></template
            >
          </multiselect>
        </b-form-group>
      </b-col>
      <b-col lg="2" md="6" sm="12"> </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Multiselect from 'vue-multiselect';
import {
  formatSolarPanelsOverallPower,
  formatSolarPanelPower,
  formatBatteryCapacity,
} from '@/helpers/projects';
import {
  formatInverterApparentPowerOverall,
  formatInverterNominalPowerOverall,
  formatInverter1Power,
  formatInverter2Power,
} from '@/helpers/inverter';
import { yesNo } from '@/helpers/enums';
import { getYesNoStateColor } from '@/helpers/colors';

export default {
  components: {
    Multiselect,
  },
  props: {
    project: { type: Object, required: true },
  },
  data() {
    return {
      filteredSolarPanels: [],
      filteredInverters: [],
      filteredBatteries: [],
      filteredEnergyFlowFirectionSensors: [],
      filteredWallboxes: [],
    };
  },
  computed: {
    ...mapGetters(['getItemsBySolarPlant']),
    solarPanelsOverallPower() {
      return formatSolarPanelsOverallPower(this.project);
    },
    solarPanelPower() {
      return formatSolarPanelPower(this.project);
    },
    inverterApparentPowerOverall() {
      return formatInverterApparentPowerOverall(this.project);
    },
    InverterNominalPowerOverall() {
      return formatInverterNominalPowerOverall(this.project);
    },
    inverter1Power() {
      return formatInverter1Power(this.project);
    },
    inverter2Power() {
      return formatInverter2Power(this.project);
    },
    batteryCapacity() {
      return formatBatteryCapacity(this.project);
    },
    optionsYesNo() {
      return yesNo();
    },
    invalidFeedbackNA() {
      return 'Voraussetzung NA';
    },
  },
  methods: {
    ...mapActions(['fetchItemsBySolarPlant']),
    yesNoColor(state) {
      return getYesNoStateColor(state);
    },
    onInverterSearch(query) {
      this.filteredInverters = this.getItemsBySolarPlant('INVERTER').filter((item) => {
        if (!query) return true;
        return (
          item.inverter.manufacturer.toLowerCase().includes(query.toLowerCase()) ||
          item.inverter.type.toLowerCase().includes(query.toLowerCase())
        );
      });
    },
    onBatterySearch(query) {
      this.filteredBatteries = this.getItemsBySolarPlant('BATTERY').filter((battery) => {
        if (!query) return true;
        return (
          battery.manufacturer.toLowerCase().includes(query.toLowerCase()) ||
          battery.type.toLowerCase().includes(query.toLowerCase())
        );
      });
    },
    onSolarPanelSearch(query) {
      this.filteredSolarPanels = this.getItemsBySolarPlant('SOLAR_PANELS').filter((solarPanel) => {
        if (!query) return true;
        return (
          solarPanel.manufacturer.toLowerCase().includes(query.toLowerCase()) ||
          solarPanel.type.toLowerCase().includes(query.toLowerCase())
        );
      });
    },
    onWallboxSearch(query) {
      this.filteredWallboxes = this.getItemsBySolarPlant('WALL_BOX').filter((wallbox) => {
        if (!query) return true;
        return (
          wallbox.manufacturer.toLowerCase().includes(query.toLowerCase()) ||
          wallbox.type.toLowerCase().includes(query.toLowerCase())
        );
      });
    },
    onEnergyFlowDirectionSensorSearch(query) {
      this.filteredEnergyFlowFirectionSensors = this.getItemsBySolarPlant(
        'ENERGY_FLOW_SENSOR'
      ).filter((sensor) => {
        if (!query) return true;
        return (
          sensor.manufacturer.toLowerCase().includes(query.toLowerCase()) ||
          sensor.type.toLowerCase().includes(query.toLowerCase())
        );
      });
    },
    requirementsValidState(field) {
      if (!this.project.netRegistrationRequirements) return false;

      const requirement = this.project.netRegistrationRequirements.find(
        (requirement) => requirement.name === field
      );
      return requirement && requirement.fullfilledState === 'YES';
    },
    async fetchItemsAndSetFiltered(solarPlantType) {
      try {
        await this.fetchItemsBySolarPlant(solarPlantType);
        return this.getItemsBySolarPlant(solarPlantType) || [];
      } catch (error) {
        console.error(`Failed to fetch items for type ${solarPlantType}:`, error);
        return [];
      }
    },
    async setup() {
      try {
        const [inverters, batteries, sensors, wallboxes, solarPanels] = await Promise.all([
          this.fetchItemsAndSetFiltered('INVERTER'),
          this.fetchItemsAndSetFiltered('BATTERY'),
          this.fetchItemsAndSetFiltered('ENERGY_FLOW_SENSOR'),
          this.fetchItemsAndSetFiltered('WALL_BOX'),
          this.fetchItemsAndSetFiltered('SOLAR_PANELS'),
        ]);

        this.filteredInverters = inverters;
        this.filteredBatteries = batteries;
        this.filteredEnergyFlowFirectionSensors = sensors;
        this.filteredWallboxes = wallboxes;
        this.filteredSolarPanels = solarPanels;
      } catch (error) {
        console.error('Error in setup:', error);
      }
    },
  },
  async mounted() {
    await this.setup();
  },
};
</script>
